import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import HeaderMenu from "./sidebar/headermenu";
import Story from "./story";
import RightWrap from "./rightside/right_wrap";
import EventWrap from "./events/event_wrap";
import { API_STATUS } from "../constants";
import { GetActiveUser } from "../apis/user/get_active_user";
import { reloadState } from "../redux/GlobalSlice";

export default function Home() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const globalState = useSelector(state => state.globalstate);

    const [userApi, setUserApi] = useState(API_STATUS);
    const [activeUser, setActiveUser] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('LOGIN_TOKEN');
        console.log("Home token", token);
        if (token == null) {
            navigate('/login');
        } else {
            sessionStorage.setItem("LOGIN_TOKEN", localStorage.getItem("LOGIN_TOKEN"));
            sessionStorage.setItem("USER_CODE", localStorage.getItem("USER_CODE"));
            sessionStorage.setItem("USER_TYPE", localStorage.getItem("USER_TYPE"));
            GetActiveUser(setUserApi);
        }
    }, []);

    const ulogout = () => {
        sessionStorage.removeItem('LOGIN_TOKEN');
        sessionStorage.removeItem('LOGIN_DaTA');

        localStorage.removeItem('LOGIN_TOKEN');
        localStorage.removeItem('LOGIN_DaTA');
        navigate('/login');
    }

    useEffect(() => {
        if (!userApi.isLoader && !userApi.isError) {
            if (userApi.data == null) {

            } else {
                let res = userApi.data;
                if (res['status'] === 409) {
                    ulogout();
                } else {
                    if (res.data['status'] === 2) {
                        navigate('/account_status');
                    }
                    // console.log(JSON.stringify(res.data));
                    sessionStorage.setItem('LOGIN_DATA', JSON.stringify(res.data));
                    localStorage.setItem('LOGIN_DATA', JSON.stringify(res.data));
                    setActiveUser(res.data);
                    dispatch(reloadState({ 'refresh_login': true }));
                    sessionStorage.setItem('KYC', res.data['kyc']);
                    sessionStorage.setItem('DECLARATION', res.data['declaration']);
                    sessionStorage.setItem('LIVENESS', res.data['liveness']);
                    sessionStorage.setItem('USER_TYPE', res.data['userType']);

                    localStorage.setItem('KYC', res.data['kyc']);
                    localStorage.setItem('DECLARATION', res.data['declaration']);
                    localStorage.setItem('LIVENESS', res.data['liveness']);
                    localStorage.setItem('USER_TYPE', res.data['userType']);
                    
                    if (res.data['declaration'] == 0) {
                        navigate('/declaration/' + res.data['kyc'] + '/' + res.data['declaration']);
                    } else if (res.data['kyc'] == 0) {
                        navigate('/kyc_pending');
                    } else if (res.data['userPic'] === '') {
                        navigate('/update_profile_pic', { state: { userData: res.data } });
                    }
                }
            }
        }
    }, [userApi]);

    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">

            <div className="main__inner">

                {/* <div onClick={ulogout}>Logout</div> */}
                <div className="flex max-lg:flex-col xl:gap-10 md:gap-3 md:mt-10" id="js-oversized">
                    <EventWrap />
                    <RightWrap />
                </div>
            </div>
        </main>
    </div>
}